import React from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Modal } from '../Styled/Misc';
import { CloseButton } from '../Styled/Buttons';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70%;
`;

function LoginMsg({ open, msg }) {
  return (
    <Modal
      open={open}
    >
      <StyledDiv>
        <h2>{msg}</h2>
        <div>
          <NavLink
            to="/"
          >
            <CloseButton
              style={{ paddingLeft: '50%' }}
            />
          </NavLink>
        </div>
      </StyledDiv>
    </Modal>
  );
}

LoginMsg.propTypes = {
  msg: PropTypes.string,
  open: PropTypes.bool.isRequired,
};

LoginMsg.defaultProps = {
  msg: null,
};

export default LoginMsg;
